import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons/faArrowLeft";

class LegacyInbound extends React.Component {

    render() {
        return (
            <>
                <div className={'cursor-pointer ml-2 emailparser-back'} onClick={(e) => {this.props.onBackAction(e)}}>
                    <FontAwesomeIcon className={`phone-icon`} icon={faArrowLeft}/> Go Back
                </div>
                <LegacyFrame withHeader={false} pageTitle={"Inbound Emails"} formname={"table_59"} customClass={"field-customization-container org-container"} />
            </>
        );
    }
}

export default LegacyInbound;
